import leadDetail from 'api/leadDetail';
import {
  GET_LEAD_DETAIL,
  UPDATE_LEAD_DETAIL
} from 'redux/sagas/actions/leadDetail';
import { HIDE_SPINNER, SHOW_SPINNER } from 'redux/slices/leadDetail';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { parseResponseLeadCustomerInfo } from 'api/helpers/lead';
import moment from 'moment';
import Toast from 'ui/components/Toast';
import i18next from 'i18next';
import { SIGNOUT } from './actions/authentication';
import { IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER } from 'const';

function* getLeadDetail({ payload }) {
  try {
    yield put(SHOW_SPINNER());
    const { data } = yield call(leadDetail.getLeadDetailApi, payload.leadId);
    const transformedData = parseResponseLeadCustomerInfo(data);
    yield put({
      type: GET_LEAD_DETAIL._SUCCESS,
      payload: transformedData
    });
  } catch (err) {
    console.log('err: ', err);
    if (err?.response?.status === 401) {
      yield put({ type: SIGNOUT._REQUEST });
    }
    yield put({ type: GET_LEAD_DETAIL._ERROR });
  } finally {
    yield put(HIDE_SPINNER());
  }
}

function* getLeadDetailWatch() {
  yield takeLatest(GET_LEAD_DETAIL._REQUEST, getLeadDetail);
}

function* updateLeadDetail({ payload }) {
  try {
    const { dataSectionTitle, data } = payload;
    const leadId = yield select(state => state.leadDetail?.data?.id);
    let updatedData = {};
    if (dataSectionTitle === 'product_preferences') {
      updatedData = {
        Product_of_Interest__c: data
          .filter(d => !d.includes(IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER))
          .join(';')
      };
    } else {
      if (data.Vehicle_Delivery__c) {
        updatedData = {
          ...data,
          Vehicle_Delivery__c: `${moment(
            data.Vehicle_Delivery__c,
            'DD/MM/YY'
          ).format('YYYY-MM-DDTHH:mm:ss.S')}Z`
        };
      } else {
        updatedData = { ...data };
      }
    }
    yield call(leadDetail.updateLeadDetail, { updatedData, leadId });

    yield put({
      type: UPDATE_LEAD_DETAIL._SUCCESS,
      payload: { sectionTitle: payload.dataSectionTitle }
    });
    yield put({ type: GET_LEAD_DETAIL._REQUEST, payload: { leadId } });
    Toast.show(
      Toast.TYPE.SUCCESS,
      i18next.t('success_edit_lead_detail', {
        field: i18next.t(dataSectionTitle)
      })
    );
  } catch (e) {
    console.log({ e });
    yield put({
      type: UPDATE_LEAD_DETAIL._ERROR,
      payload: { sectionTitle: payload.dataSectionTitle }
    });
    // eslint-disable-next-line no-unused-expressions
    Toast.show(Toast.TYPE.ERROR, i18next.t('error_edit_lead_detail'));
  }
}

function* updateLeadDetailWatch() {
  yield takeLatest(UPDATE_LEAD_DETAIL._REQUEST, updateLeadDetail);
}

export default [getLeadDetailWatch(), updateLeadDetailWatch()];
